import { Loader } from 'google-maps';
import gsap from 'gsap/gsap-core';

export default {
	name: "AppContact",
	props: {
		places: {
			type: Array
		},
		apikey: {
			type: String
		}
	},
	data() {
		return {
			mountedDone: false,
			styles: [[
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"visibility": "on"
						},
						{
							"weight": 0.9
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#1f8a70"
						},
						{
							"weight": 0.7
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#1f8a70"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#1f8a70"
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#fd7400"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway.controlled_access",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#1f8a70"
						},
						{
							"lightness": -20
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#1f8a70"
						},
						{
							"lightness": -17
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#1f8a70"
						},
						{
							"lightness": -10
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#004358"
						}
					]
				}
			], [
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"visibility": "on"
						},
						{
							"weight": 0.9
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#136957"
						},
						{
							"weight": 0.7
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#136957"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#136957"
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#fd7400"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.highway.controlled_access",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#136957"
						},
						{
							"lightness": -20
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#136957"
						},
						{
							"lightness": -17
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#136957"
						},
						{
							"lightness": -10
						},
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#004358"
						}
					]
				}
			]],
			tl: null,
			isAnimated: true,
			placeAdress: [],
			googleMapFetched: true
		}
	},
	created() {
		window.addEventListener('resize', this.handleResize);
	},
	mounted() {
		this.mapWrapper = document.querySelectorAll('.contact__places__container__wrapper');
		this.mapContainer = document.querySelectorAll('.contact__places__container__wrapper__map');
		this.placeContainer = document.querySelectorAll('.contact__places__container');
		this.placeAdress = document.querySelectorAll('.contact__places__container__content');
		window.addEventListener('scroll', this.enterAnimation)
		this.setMapPosition();

	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		enterAnimation() {
			const offsetTop = 400

			const enterAnimation = window.pageYOffset + this.$refs.contactPlaces.offsetHeight - offsetTop - this.$refs.contactPlaces.offsetTop
			if (enterAnimation > 0) {
				if (!this.isAnimated) return
				if (this.tl && this.tl.isActive()) {
					this.tl.kill()
				}
				this.isAnimated = false
				this.tl = gsap.timeline({
					onComplete: () => {
						if (this.googleMapFetched) {
							this.initMap();
							this.googleMapFetched = false
						}
					}
				})
					.fromTo(this.mapContainer, { duration: 0.4, scale: 0 }, { scale: 1, opacity: 1, stagger: 0.1 })
					.fromTo(this.placeAdress, { duration: 0.4, y: 50, opacity: 0 }, { y: 0, opacity: 1 }, '-=0.4')
			} else {
				if (this.tl && !this.isAnimated) {
					if (this.tl.isActive()) {
						this.tl.kill()
					}
					this.isAnimated = true;
					this.tl.reverse()
				}
			}
		},
		async initMap() {
			const loader = new Loader(this.apikey);
			const google = await loader.load();

			let iconBase = { url: '/wp-content/themes/averton/dist/assets/pin.png', scaledSize: new google.maps.Size(25, 36) };

			this.mapContainer.forEach((el, index) => {
				let map = new google.maps.Map(el, {
					center: { lat: this.places[index].location.lat, lng: this.places[index].location.lng },
					zoom: this.places[index].location.zoom,
					disableDefaultUI: true,
					styles: this.styles[index],
					gestureHandling: "none",
					draggableCursor: "cursor"
				});

				let marker = new google.maps.Marker({
					position: { lat: this.places[index].location.lat, lng: this.places[index].location.lng },
					icon: iconBase,
					map: map
				});

				map.addListener("click", function (e) {
					e.stop();
					window.open(`https://www.google.com/maps/search/?api=1&query=${this.center.lat()},${this.center.lng()}`);
				})

				marker.addListener("click", function (e) {
					e.stop();
					window.open(`https://www.google.com/maps/search/?api=1&query=${map.center.lat()},${map.center.lng()}`);
				})

				gsap.set(el.children[0], { backgroundColor: "rgba(128, 128, 128, 0.5) !important" })
			})

		},
		setMapPosition() {

			let mobile = window.matchMedia('(max-width: 420px)');

			if (mobile.matches) {
				this.placeContainer.forEach(el => {
					el.style.removeProperty("transform");
				})

				this.mapWrapper.forEach((el, index) => {
					const odd = index % 2;
					const behindGrid = 20;

					if (!odd) {
						const elWidth = el.children[0].offsetWidth;
						const leftGrid = this.$refs.contact.offsetLeft;
						const transformValue = elWidth - window.innerWidth + behindGrid + leftGrid;

						el.style.transform = `translateX(${-transformValue}px)`
					} else {
						el.style.transform = `translateX(${-behindGrid}px)`
					}
				})
			} else {
				this.mapWrapper.forEach(el => {
					el.style.removeProperty("transform");
				})

				this.placeContainer.forEach((el, index) => {
					const even = index % 2;

					if (even) {
						const elWidth = el.offsetWidth;
						const elLeftOffset = el.offsetLeft;
						const gridSpace = this.$refs.contactPlaces.getBoundingClientRect().left
						const transformValue = elWidth + elLeftOffset + gridSpace - window.innerWidth;

						el.style.transform = `translateX(${-transformValue}px)`
					}
				})
			}
		},
		handleResize() {
			this.setMapPosition();
		}
	}
}